'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionViewDay = function ActionViewDay(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M2 21h19v-3H2v3zM20 8H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h17c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zM2 3v3h19V3H2z' })
  );
};
ActionViewDay = (0, _pure2.default)(ActionViewDay);
ActionViewDay.displayName = 'ActionViewDay';
ActionViewDay.muiName = 'SvgIcon';

exports.default = ActionViewDay;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/action/view-day.js
 ** module id = 1623
 ** module chunks = 0
 **/